(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-mega-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Only run on desktop
  if (window.innerWidth <= 768) {
    return;
  }
  
  const visualNavItems = document.querySelectorAll('.site-nav--visual-nav[data-menu-trigger]');
  const megaMenuPanels = document.querySelectorAll('.visual-nav-megamenu[data-menu-panel]');
  const megaMenuWrapper = document.querySelector('.visual-nav-megamenu-wrapper');
  
  // Exit if no visual nav items found
  if (visualNavItems.length === 0) {
    return;
  }
  
  // Clear any inline styles on panels from previous page loads
  megaMenuPanels.forEach(panel => {
    panel.style.display = '';
    panel.style.opacity = '';
    panel.style.visibility = '';
  });
  
  let currentActivePanel = null;
  let currentActiveItem = null;
  let hoverTimeout = null;
  
  // Position mega menu wrapper relative to nav items
  function positionMegaMenu(activeNavItem) {
    // Try to get the navigation container first
    const navContainer = document.querySelector('.site-nav');
    const siteHeader = document.querySelector('#SiteHeader');
    
    if (megaMenuWrapper) {
      let targetElement = null;
      
      // If we have an active nav item, use its position
      if (activeNavItem) {
        targetElement = activeNavItem;
      } else if (navContainer) {
        // Otherwise use the nav container
        targetElement = navContainer;
      } else if (siteHeader) {
        // Fallback to header if nav container not found
        targetElement = siteHeader;
      }
      
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const bottomPosition = rect.bottom;
        
        // Position wrapper directly below the nav item/container
        megaMenuWrapper.style.top = bottomPosition + 'px';
        megaMenuWrapper.style.position = 'fixed';
      }
    }
  }
  
  positionMegaMenu();
  window.addEventListener('resize', () => positionMegaMenu(currentActiveItem));
  window.addEventListener('scroll', () => positionMegaMenu(currentActiveItem));
  
  // Show mega menu panel
  function showPanel(panelId, navItem) {
    // Position menu relative to the nav item
    positionMegaMenu(navItem);

    // Close all other nav items and update aria-expanded
    visualNavItems.forEach(item => {
      if (item !== navItem) {
        item.classList.remove('is-focused');
        const itemLink = item.querySelector('a');
        if (itemLink && itemLink.hasAttribute('aria-expanded')) {
          itemLink.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Hide all panels first
    megaMenuPanels.forEach(panel => {
      panel.classList.remove('is-active');
    });

    // Add is-focused class to nav item (matches theme's existing behavior)
    if (navItem) {
      navItem.classList.add('is-focused');
      currentActiveItem = navItem;

      // Update aria-expanded to true
      const navLink = navItem.querySelector('a');
      if (navLink && navLink.hasAttribute('aria-expanded')) {
        navLink.setAttribute('aria-expanded', 'true');
      }
    }

    // Find and show the matching panel
    const targetPanel = document.querySelector(`.visual-nav-megamenu[data-menu-panel="${panelId}"]`);

    if (targetPanel) {
      // Make wrapper interactive
      megaMenuWrapper.style.pointerEvents = 'auto';

      // Clear any inline styles that might be blocking visibility
      targetPanel.style.display = '';
      targetPanel.style.opacity = '';
      targetPanel.style.visibility = '';

      // Add active class immediately
      targetPanel.classList.add('is-active');

      currentActivePanel = panelId;
    }
  }
  
  // Hide all panels
  function hideAllPanels() {

    // Remove is-focused from all nav items and update aria-expanded
    visualNavItems.forEach(item => {
      item.classList.remove('is-focused');
      const itemLink = item.querySelector('a');
      if (itemLink && itemLink.hasAttribute('aria-expanded')) {
        itemLink.setAttribute('aria-expanded', 'false');
      }
    });

    // Hide all panels by removing active class
    megaMenuPanels.forEach(panel => {
      panel.classList.remove('is-active');
    });

    // Make wrapper non-interactive
    megaMenuWrapper.style.pointerEvents = 'none';

    currentActivePanel = null;
    currentActiveItem = null;
  }
  
  const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getPanel(menuTrigger) {
    return document.querySelector(`.visual-nav-megamenu[data-menu-panel="${menuTrigger}"]`);
  }

  function getPanelFocusables(panel) {
    return panel ? Array.from(panel.querySelectorAll(focusableSelector)) : [];
  }

  function isOpen(link) {
    return link.getAttribute('aria-expanded') === 'true';
  }

  function focusAdjacentNavLink(item, direction) {
    const items = Array.from(visualNavItems);
    const index = items.indexOf(item);
    const next = items[index + direction];
    const nextLink = next ? next.querySelector('a') : null;
    if (nextLink) {
      nextLink.focus();
      return true;
    }
    return false;
  }

  // Setup event handlers for each nav item
  visualNavItems.forEach(item => {
    const menuTrigger = item.getAttribute('data-menu-trigger');
    const link = item.querySelector('a');

    // A menu link with children but no matching mega menu block would leave
    // aria-controls pointing at nothing; expose it as a plain link instead.
    if (link && !getPanel(menuTrigger)) {
      ['aria-controls', 'aria-expanded', 'aria-haspopup', 'aria-describedby']
        .forEach(attr => link.removeAttribute(attr));
    }

    // Mouse events
    item.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      showPanel(menuTrigger, item);
    });

    item.addEventListener('mouseleave', function(e) {
      const toElement = e.relatedTarget;
      if (!toElement || !toElement.closest('.visual-nav-megamenu-wrapper')) {
        hoverTimeout = setTimeout(() => {
          hideAllPanels();
        }, 100);
      }
    });

    if (!link) return;

    // Focus does not open the panel. The user opens it with Enter, Space or
    // Arrow Down, so Tab moves between top-level items without detours.
    link.addEventListener('blur', function(e) {
      const relatedTarget = e.relatedTarget;
      if (!relatedTarget || !relatedTarget.closest('.visual-nav-megamenu-wrapper')) {
        hoverTimeout = setTimeout(() => {
          hideAllPanels();
        }, 100);
      }
    });

    link.addEventListener('keydown', function(e) {
      const panel = getPanel(menuTrigger);
      if (!panel) return;

      switch (e.key) {
        case 'Enter':
        case ' ':
          // First press opens the submenu. Enter on an open submenu follows the link.
          if (!isOpen(link)) {
            e.preventDefault();
            showPanel(menuTrigger, item);
          } else if (e.key === ' ') {
            e.preventDefault();
            hideAllPanels();
          }
          break;
        case 'ArrowDown': {
          e.preventDefault();
          if (!isOpen(link)) showPanel(menuTrigger, item);
          const [first] = getPanelFocusables(panel);
          if (first) first.focus();
          break;
        }
        case 'ArrowUp':
          if (isOpen(link)) {
            e.preventDefault();
            hideAllPanels();
          }
          break;
        case 'Tab':
          // Tab from an open trigger enters its submenu, so the submenu sits
          // directly after its parent in the focus order.
          if (isOpen(link) && !e.shiftKey) {
            const [first] = getPanelFocusables(panel);
            if (first) {
              e.preventDefault();
              clearTimeout(hoverTimeout);
              first.focus();
            }
          }
          break;
        default:
          break;
      }
    });
  });

  // Keyboard handling inside the open panel
  megaMenuPanels.forEach(panel => {
    panel.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      const focusables = getPanelFocusables(panel);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const item = currentActiveItem;
      const link = item ? item.querySelector('a') : null;

      if (e.shiftKey && document.activeElement === first && link) {
        // Back to the parent menu item
        e.preventDefault();
        clearTimeout(hoverTimeout);
        link.focus();
      } else if (!e.shiftKey && document.activeElement === last && item) {
        // Leave the submenu and continue with the next menu item
        e.preventDefault();
        hideAllPanels();
        if (!focusAdjacentNavLink(item, 1)) {
          const afterNav = document.querySelector('#MainContent');
          if (afterNav) {
            afterNav.setAttribute('tabindex', '-1');
            afterNav.focus();
          }
        }
      }
    });
  });

  // Keep mega menu open when hovering over it
  if (megaMenuWrapper) {
    megaMenuWrapper.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
    });
    
    megaMenuWrapper.addEventListener('mouseleave', function() {
      hoverTimeout = setTimeout(() => {
        hideAllPanels();
      }, 100);
    });
    
    // Allow tabbing through mega menu links
    megaMenuWrapper.addEventListener('focusin', function() {
      clearTimeout(hoverTimeout);
    });
    
    megaMenuWrapper.addEventListener('focusout', function(e) {
      const relatedTarget = e.relatedTarget;
      const activeLink = currentActiveItem ? currentActiveItem.querySelector('a') : null;
      if (!relatedTarget ||
          (!relatedTarget.closest('.visual-nav-megamenu-wrapper') &&
           relatedTarget !== activeLink)) {
        hoverTimeout = setTimeout(() => {
          hideAllPanels();
        }, 100);
      }
    });
  }
  
  // Escape key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && currentActivePanel) {
      // Capture the trigger before hideAllPanels() clears it
      const activeLink = currentActiveItem ? currentActiveItem.querySelector('a') : null;
      hideAllPanels();
      if (activeLink) activeLink.focus();
    }
  });
  
  // Close on click outside
  document.addEventListener('click', function(e) {
    if (currentActivePanel && 
        !e.target.closest('.visual-nav-megamenu-wrapper') && 
        !e.target.closest('.site-nav--visual-nav')) {
      hideAllPanels();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
